import type { StatisticItem } from '../types';

export const statistics: StatisticItem[] = [
  {
    label: 'AÑOS DE EXPERIENCIA',
    value: 38,
    suffix: '+',
  },
  {
    label: 'PRUEBAS ACREDITADAS',
    value: 84,
    suffix: '',
  },
  {
    label: 'CLIENTES ESTRATÉGICOS',
    value: 1100,
    suffix: '',
  },
  {
    label: 'PROYECTOS REALIZADOS',
    value: 800,
    suffix: '+',
  },
];